import { render, staticRenderFns } from "./eAristoStudentStatisticsView.vue?vue&type=template&id=eb497490"
import script from "./eAristoStudentStatisticsView.vue?vue&type=script&lang=js"
export * from "./eAristoStudentStatisticsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports